<template>
  <my-modal
    :title="followTitTxt"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :footer="false"
  >
    <div slot="content">
      <h3 class="title">
        {{ title }}
      </h3>
      <div class="content">
        <a-select
          v-if="type === 'assign' && assignOptions"
          ref="assignSelect"
          :placeholder="selectPlaceholder"
          @change="handleChangeSelect"
        >
          <a-select-option
            v-for="item in assignOptions"
            :key="item.userid"
            :value="item.userid"
          >
            {{ item.truename }}
          </a-select-option>
        </a-select>
        <template v-else-if="type === 'receive'">
          <div class="receive">
            {{ $t('message["614"]') }}？
          </div>
        </template>
        <template v-else-if="type === 'allocate'">
          <a-checkbox
            v-if="enableshare"
            :checked="is_shared"
            @change="onChangeShare"
          >
            {{ $t('message["1725"]') }}
          </a-checkbox>
          <div
            class="btn"
            @click="showCascader"
          >
            <span
              v-if="valueDesc"
              class="name fs-blue"
            >{{ valueDesc }}</span>
            <span
              v-else
              class="name"
            >{{ $t('message["855"]') }}</span>
            <i class="iconfont iconicon-test18" />
          </div>
        </template>
        <template v-else-if="type === 'transfer'">
          <a-checkbox
            v-if="enableshare"
            :checked="is_shared"
            @change="onChangeShare"
          >
            {{ $t('message["1725"]') }}
          </a-checkbox>
          <div
            class="btn"
            @click="showCascader"
          >
            <span
              v-if="valueDesc"
              class="name fs-blue"
            >{{ valueDesc }}</span>
            <span
              v-else
              class="name"
            >{{ $t('message["855"]') }}</span>
            <i class="iconfont iconicon-test18" />
          </div>
        </template>
      </div>
      <cube-form-group class="cube-picker-footer footer">
        <cube-button
          type="reset"
          class="cancel-btn"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          class="confirm-btn"
          @click="handleOk"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </cube-form-group>
    </div>
  </my-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getAuthTeamInfo, getTeamGroupDetail } from '@/services/index'
import { inquiryReceive, inquiryAssign, inquiryTransfer, inquiryAllocate } from '@/services/inqueryServices'
import eventBus from '@/lib/eventBus'
import MyModal from '@/components/mobile/Modal'

export default {
  components: {
    MyModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    },
    groupid: {
      type: [String, Number],
      default: () => { }
    },
    type: {
      type: String,
      default: ''
    },
    currentItem: {
      type: Object,
      default: () => ({})
    },
    isShared: {
      type: Boolean,
      default: false
    }
  },
  data () {
    let valueDesc = this.currentItem.valueDesc
    let isShared = this.isShared
    return {
      confirmLoading: false,
      data: {},
      is_shared: isShared,
      valueDesc,
      assignOptions: [],
      divides: {
        1: this.$t('message["299"]'), // 分配到人
        2: this.$i18n.t('message["714"]'), // 平均分配
        3: this.$i18n.t('message["3"]'), // 按额度分配
        4: this.$i18n.t('message["1763"]') // 负责人指派
      }
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    title () {
      let string = ''
      switch (this.type) {
        case 'transfer':
          string = this.$t('message["483"]') + '：'
          break
        case 'assign':
          string = this.$t('message["482"]') + '：'
          break
        case 'receive':
          string = this.$t('message["489"]')
          break
        case 'allocate':
          string = this.$t('message["481"]') + '：'
          break
      }
      return string
    },
    followTitTxt () {
      return this.$t('message["373"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    }
  },
  watch: {
    async visible (val) {
      this.data = Object.assign({}, this.currentItem)
      if (val) {
        this.is_shared = this.isShared
        if (this.assignOptions && !this.assignOptions.length) {
          this.assignOptions = await this.getGroupDetail()
        }
      }
    },
    data: {
      handler (val) {
        this.valueDesc = val.valueDesc || this.setValueDesc(val)
      },
      deep: true
    },
    currentItem: {
      handler (val) {
        if (val.submit) {
          this.valueDesc = val.valueDesc || this.setValueDesc(val)
          this.data = Object.assign({}, this.currentItem)
        }
      },
      deep: true
    }
  },
  async created () {
    this.assignOptions = await this.getGroupDetail()
  },
  methods: {
    ...mapMutations('inquery/relateData', ['SET_RECYCLE_LOG_TIPS']),
    showCascader () {
      eventBus.$emit('toggleFollowCascaderModal', true)
    },
    async getData (obj = {}) {
      let { type } = obj
      let inquiryType = this.type || obj.inquiryType
      let params = { pk: 'inquiry-followup', type: 0 }
      if (type) { // 共享
        params.type = type
      }

      // 不选择共享；信息类型不是备案 // && !this.isBeiAn
      if (inquiryType === 'allocate' && !this.is_shared) {
        params.divide = 1 // 出现四列
      }

      // 分配或转移，并且非共享  && !this.is_shared
      if ((inquiryType === 'transfer' || inquiryType === 'allocate')) {
        params.deal = 1 // 去除空组和空团队
      }

      const result = await getAuthTeamInfo()
        .params({
          ...params
        }
        ).fetch()

      const { payload: data = [] } = (result && result.data) || {}
      /* if (this.type === 'transfer') {
        if (!this.is_shared) {
          this.setGroupEmpty(data)
          this.setRoleEmpty(data)
        }
      } else if (this.type === 'allocate') {
        if (!this.is_shared) {
          this.setGroupEmpty(data)
          this.setRoleEmpty(data)

          this.setFollowData(data)
        }
      } */
      if (this.type === 'allocate' && !this.is_shared) {
        this.setFollowData(data)
      }
      return data
    },
    /**
     * 当分配方式是1，选到人，不是1，删除掉人的 children 数据
     */
    setFollowData (data) {
      for (let item of data) {
        if (item.hasOwnProperty('divide_type') && item.divide_type.length === 1 && item.divide_type[0] !== 1) {
          item.children = []
        }
        if (item.children && item.children.length) {
          this.setFollowData(item.children)
        }
      }
    },
    /* setGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'groupid' && (!item.children || !item.children.length)) {
          // item.disabled = true
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setGroupEmpty(item.children)
        }
      }
    }, */
    setRoleEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'roleid' && (!item.children || !item.children.length)) {
          data.splice(i, 1)
        }
      }
    },
    async getGroupDetail () {
      if (!this.groupid) return

      const result = await getTeamGroupDetail()
        .params({
          groupid: this.groupid
        }).fetch()
      const { payload = {} } = (result && result.data) || {}
      const { member = {} } = payload
      const { list = [] } = member
      return list
    },
    async onChangeShare (e) {
      this.is_shared = e.target.checked
      this.data.fieldvalue = []
      this.data.info = {}
      eventBus.$emit('clearCascader')
      this.valueDesc = this.setValueDesc(this.currentItem)

      let type = this.is_shared ? 1 : 0

      let data = await this.getData({ type })
      if (type === 1) {
        this.setRoleEmpty(data)
      }
      eventBus.$emit('updateFollowOptions', data, this.is_shared)
    },
    handleChangeSelect (val) {
      this.data.info.userid = val
    },
    setValueDesc (data) {
      let desc = ''
      const { info = {} } = data || {}
      const { divides } = this
      const { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, truename = '', rolename = '', groupname = '' } = info

      if (roleid) {
        desc += rolename + '/'
      }
      if (groupid) {
        desc += groupname + '/'
      }
      /* if (userid) {
        desc += truename
      } */
      if (divideType === 1 && userid) {
        desc += divides[divideType]
        desc += truename
      } else if (userid && !divideType) {
        desc += truename
      } else if (divideType) {
        desc += divides[divideType]
      }

      return desc
    },
    hide () {
      this.$emit('update:visible', false)
      eventBus.$emit('toggleFollowCascaderModal', false)
    },
    async handleOk () {
      const { type, inquiryId: inquiryid, data = {} } = this
      const { info = {} } = data
      const { roleid = 0, groupid = 0, userid = 0, divide_type: divideType } = info
      let chain
      let params = {
        inquiryid
      }
      if (this.confirmLoading) return

      if (type === 'receive') {
        chain = await inquiryReceive()
      } else if (type === 'assign') {
        if (userid === 0) {
          this.$selefToast({ type: 'error', text: this.$t('message["855"]') })
          return
        }
        chain = await inquiryAssign()
      } else if (type === 'transfer') {
        if (roleid === 0 && groupid === 0 && userid === 0) {
          this.$selefToast({ type: 'error', text: this.$t('message["855"]') })
          return
        }
        chain = await inquiryTransfer()
        params.isshared = this.is_shared ? 1 : 0
      } else if (type === 'allocate') {
        if (roleid === 0 && groupid === 0 && userid === 0) {
          this.$selefToast({ type: 'error', text: this.$t('message["855"]') })
          return
        }
        if (divideType) {
          params.divide_type = divideType
        }
        chain = await inquiryAllocate()
        params.is_shared = this.is_shared
      }

      params.roleid = roleid
      params.groupid = groupid
      params.userid = userid

      this.confirmLoading = true
      chain
        .onNetSuccess((res) => {
          this.confirmLoading = false
        })
        .onSuccess(payload => {
          this.hide()
          if (type === 'transfer') {
            this.$router.push({
              name: 'InqueryList',
              query: {
                ...this.$route.query
              }
            })
          } else {
            eventBus.$emit('fetchInquiryDetail')
          }
          this.SET_RECYCLE_LOG_TIPS('')
        }).params(params)
        .fetch()
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
h3.title {
  margin-bottom: 20px;
  font-weight: bold;
}
::v-deep .ant-checkbox-wrapper {
  margin-bottom: 25px;
}
::v-deep .cube-picker-panel {
  width: 270px;
  height: auto;
}
::v-deep .ant-form-item-label {
  display: none;
}
::v-deep .ant-cascader-picker {
  width: 240px;
  text-align: left;
}
::v-deep .ant-select-selection--single {
  width: 200px;
}
.receive {
  padding: 0 20px;
  line-height: 1.5;
}
.btn {
  display: flex;
  flex: 1;
  justify-content: center;
  color: #999;
}
.name {
  line-height: 1;
  align-self: center;
}

.iconfont {
  color: #ccc;
}

.cube-picker-footer ::v-deep {
  margin-top: 16px;
  height: 50px;
  line-height: 50px;
  border-top: solid 1px #dbdbdb;
  .cube-btn {
    display: inline-block;
    width: 50%;
    padding: 0;
    color: $gray2;
    background-color: #fff;
    border-radius: 0;
    &:first-child {
      border-right: solid 1px #dbdbdb;
    }
    &.confirm-btn {
      color: $primary-color;
    }
  }
}
</style>
<style lang="scss">
/* .follow-modal {
  .cube-popup-container,
  .cube-popup-mask {
    width: 375px;
    height: 100vh;
  }
  .filter-wrap {
    .cube-popup-content {
      position: fixed;
      left: -50%;
      top: -50%;
      text-align: left;
      margin: -230px 0 0 -53px;
      text-align: left;
    }
    .operate-btn-div {
      width: 100%;
    }
  }
} */
</style>
